import { RAW_FILES_PATH } from '../../common/consts/path'

export const RAW_CHAINS_FILES_PATH = `${RAW_FILES_PATH}/src/chains`
